import { aiCreditErrorMessage } from '../../features/ai-chat/models/aiCreditSignals';
import axios from "axios";
import { AI_CHATS_API } from "./constants";

export const OPENAI_CREDITS_EXHAUSTED_MESSAGE = "OpenAI API credits are exhausted. Add credits in the OpenAI Platform billing settings or select another default provider.";

export function newAiChatPayload(title) {
  return { title: String(title || "").trim() };
}

export function createOrdinaryAiChat(title) {
  return axios.post(AI_CHATS_API, newAiChatPayload(title));
}

export function aiExecutionErrorMessage(error, fallback = "AI generation failed.") {
  const creditMessage = aiCreditErrorMessage(error); if (creditMessage) return creditMessage;
  const response = error?.response;
  const data = response?.data;
  const source = data ?? error;
  const code = source?.code || source?.error?.code || source?.error_code;
  const rawMessage = source?.message || source?.error?.message || (typeof source?.error === "string" ? source.error : null) || (typeof source === "string" ? source : null);
  const normalizedMessage = String(rawMessage || "").toLowerCase();
  const exhausted = code === "credit_balance_exhausted"
    || normalizedMessage.includes("credit_balance_exhausted")
    || (normalizedMessage.includes("credit balance") && (normalizedMessage.includes("exhaust") || normalizedMessage.includes("too low") || normalizedMessage.includes("insufficient")));

  if (response?.status === 429 && exhausted) return OPENAI_CREDITS_EXHAUSTED_MESSAGE;
  if (exhausted) return OPENAI_CREDITS_EXHAUSTED_MESSAGE;
  return rawMessage || fallback;
}
